import {GraphQLService} from "./graphql.service";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Product} from "../models/product.model";
import {Observable} from "rxjs";
import {Pagination} from "../models/pagination.model";
import {TranslateService} from "@ngx-translate/core";
import {CurrencyPrice} from "../models/currency_price.model";
import {Language} from "../models/language.model";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable()
export class ProductService extends GraphQLService<Product> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    super(http, snackBar);
    /* DO NOT DELETE */
    new Product()
    new CurrencyPrice()
    new Language()
    /* DO NOT DELETE END */
  }

  byEAN(ean: string) {
    return this.find(`{ product(isbn: "${ean}") { id title internalId priceNetto
    productBook { title language subtitle blurb isbn hardcover numpages publishedAt publisher { name url } }
    currencyPrices { currency exchangeRate netPrice }
    category { id }
    } }`)
  }

  byCategory(categoryId: string, page = 1, languageStr: string | undefined): Observable<Product[]> {
    return this.findAll(`{ productsByCategory(categoryId: ${categoryId}, page: ${page}, languages: "${languageStr}") { id title internalId currencyPrices { currency exchangeRate netPrice } }
    pagination { totalPages totalEntries currentPage previousPage nextPage perPage }
    aggregations { i18n default counter code2 code3 }
    }`)
  }

  bySearchTerm(term: string, page = 1, languageStr: string | undefined): Observable<Product[]> {
    return this.findAll(`{ productSearch(term: "${term}", page: ${page}, languages: "${languageStr}") { id title internalId currencyPrices { currency exchangeRate netPrice } }
    pagination { totalPages totalEntries currentPage previousPage nextPage perPage }
    aggregations { i18n default counter code2 code3 }
    }`)
  }

  pagination(): Pagination<Product> | undefined {
    return this.lastPagination
  }

  aggregations(): Language[] | undefined {
    return this.lastAggregations
  }

  latestProducts(iso = this.translate.currentLang): Observable<Product[]> {
    return this.findAll(`{ latestProducts(iso: "${iso}") { id title internalId currencyPrices { currency exchangeRate netPrice } } }`)
  }

}
